import PropTypes from "prop-types";

import Wrapper from "../../helpers/Wrapper";
import { SwiperSlide } from "swiper/react";
import Card from "../Card";
import Slider from "../Slider";
import ComparePostCard from "../ComparePostCard";
import { AllCardDataSample } from "../../../data/cardDataSamples";
import LineLoaderImg from "../../../assets/images/chart-loaders/line.png";
import LineLoaderImgWebp from "../../../assets/images/chart-loaders/line.webp";
import DonutChartLoaderImg from "../../../assets/images/chart-loaders/donut.png";
import DonutChartLoaderImgWebp from "../../../assets/images/chart-loaders/donut.webp";
import SemiDonutChartLoaderImg from "../../../assets/images/chart-loaders/semidonut.png";
import SemiDonutChartLoaderImgWebp from "../../../assets/images/chart-loaders/semidonut.webp";
import SankeyChartLoaderImg from "../../../assets/images/chart-loaders/sankey.png";
import SankeyChartLoaderImgWebp from "../../../assets/images/chart-loaders/sankey.webp";
import StackedChartLoaderImg from "../../../assets/images/chart-loaders/stacked.png";
import StackedChartLoaderImgWebp from "../../../assets/images/chart-loaders/stacked.webp";
import PieChartLoaderImg from "../../../assets/images/chart-loaders/pie.png";
import PieChartLoaderImgWebp from "../../../assets/images/chart-loaders/pie.webp";
import HeatChartLoaderImg from "../../../assets/images/chart-loaders/heat.png";
import HeatChartLoaderImgWebp from "../../../assets/images/chart-loaders/heat.webp";
import TreeChartLoaderImg from "../../../assets/images/chart-loaders/tree.png";
import TreeChartLoaderImgWebp from "../../../assets/images/chart-loaders/tree.webp";
import MapChartLoaderImg from "../../../assets/images/chart-loaders/map.png";
import MapChartLoaderImgWebp from "../../../assets/images/chart-loaders/map.webp";
import BarChartLoaderImg from "../../../assets/images/chart-loaders/bar.png";
import BarChartLoaderImgWebp from "../../../assets/images/chart-loaders/bar.webp";
import SolidGaugeChartLoaderImg from "../../../assets/images/chart-loaders/solidgauge.png";
import SolidGaugeChartLoaderImgWebp from "../../../assets/images/chart-loaders/solidgauge.webp";
import CombinedBarLineChartLoaderImg from "../../../assets/images/chart-loaders/barlinecombined.png";
import CombinedBarLineChartLoaderImgWebp from "../../../assets/images/chart-loaders/barlinecombined.webp";
import TableLoaderImg from "../../../assets/images/chart-loaders/table.png";
import TableLoaderImgWebp from "../../../assets/images/chart-loaders/table.webp";
import GenderLoaderImg from "../../../assets/images/chart-loaders/gender.png";
import GenderLoaderImgWebp from "../../../assets/images/chart-loaders/gender.webp";
import HashLoaderImg from "../../../assets/images/chart-loaders/hash.png";
import HashLoaderImgWebp from "../../../assets/images/chart-loaders/hash.webp";
import CardLoaderImg from "../../../assets/images/chart-loaders/card.png";
import CardLoaderImgWebp from "../../../assets/images/chart-loaders/card.webp";
import ImgLoaderImg from "../../../assets/images/chart-loaders/img.png";
import ImgLoaderImgWebp from "../../../assets/images/chart-loaders/img.webp";
import MultiAxesChartLoaderImg from "../../../assets/images/chart-loaders/multiaxes.png";
import MultiAxesChartLoaderImgWebp from "../../../assets/images/chart-loaders/multiaxes.webp";
import FunnelLoaderImg from "../../../assets/images/chart-loaders/funnel.png";
import FunnelLoaderImgWebp from "../../../assets/images/chart-loaders/funnel.webp";
import BubbleLoaderImg from "../../../assets/images/chart-loaders/bubble.png";
import BubbleLoaderImgWebp from "../../../assets/images/chart-loaders/bubble.webp";
import IndiaMapLoaderImg from "../../../assets/images/chart-loaders/india-map.png";
import IndiaMapLoaderImgWebp from "../../../assets/images/chart-loaders/india-map.webp";
import MultiLineMultiAxisLoaderImg from "../../../assets/images/chart-loaders/multiaxismultiline.png";
import MultiLineMultiAxisLoaderImgWebp from "../../../assets/images/chart-loaders/multiaxismultiline.webp";
import WordCloudLoaderImg from "../../../assets/images/chart-loaders/wordcloud.png";
import WordCloudLoaderImgWebp from "../../../assets/images/chart-loaders/wordcloud.webp";
import PackedCircleLoaderImg from "../../../assets/images/chart-loaders/packedcircle.png";
import PackedCircleLoaderImgWebp from "../../../assets/images/chart-loaders/packedcircle.webp";
const Loader = ({ loaderType, variantType, title, message }) => {
  return (
    <Wrapper>
      {loaderType === "cardLoader" ? (
        <Wrapper>
          <div className="grid">
            <div className="card_wrapper">
              {!variantType && (
                <Slider sliderTitle={"Summary"} isSkeleton={true}>
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        key={index}
                        cardTitle={data.label}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        rowOneTitle={"Previous"}
                        numberVariant={"number"}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "compare" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"compare"}
                        showPreviousCompare={true}
                        cardIconLink={data.brand_logo}
                        cardTitle={data.cardTitle}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        second_currentValue={data.second_currentValue}
                        second_previousValue={data.second_previousValue}
                        rowOneTitle={data.rowOneTitle}
                        rowTwoTitle={data.rowTwoTitle}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "chartCard" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"chartCard"}
                        cardTitle={data.label}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "target" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"target"}
                        showPreviousCompare={true}
                        cardIconLink={data.brand_logo}
                        cardTitle={data.cardTitle}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        second_currentValue={data.second_currentValue}
                        second_previousValue={data.second_previousValue}
                        rowOneTitle={data.rowOneTitle}
                        rowTwoTitle={data.rowTwoTitle}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "twitter_top_mentions" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"twitter_top_mentions"}
                        showPreviousCompare={true}
                        cardIconLink={data.brand_logo}
                        cardTitle={data.cardTitle}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        second_currentValue={data.second_currentValue}
                        second_previousValue={data.second_previousValue}
                        rowOneTitle={data.rowOneTitle}
                        rowTwoTitle={data.rowTwoTitle}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "twitter_top_followers" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"twitter_top_followers"}
                        showPreviousCompare={true}
                        cardIconLink={data.brand_logo}
                        cardTitle={data.cardTitle}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        second_currentValue={data.second_currentValue}
                        second_previousValue={data.second_previousValue}
                        rowOneTitle={data.rowOneTitle}
                        rowTwoTitle={data.rowTwoTitle}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "video_thumbnail" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"video_thumbnail_loader"}
                        cardIconLink={data.brand_logo}
                        cardClass
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "AdminBucketList" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"AdminBucketList"}
                        showPreviousCompare={true}
                        cardIconLink={data.brand_logo}
                        cardTitle={data.cardTitle}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        second_currentValue={data.second_currentValue}
                        second_previousValue={data.second_previousValue}
                        rowOneTitle={data.rowOneTitle}
                        rowTwoTitle={data.rowTwoTitle}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "singleLineChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={LineLoaderImgWebp} type="image/webp" />
                  <source srcSet={LineLoaderImg} type="image/png" />
                  <img src={LineLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "imageLoader" ? (
        <Wrapper>
          <div className="loader_img_wrapper">
            <div className="skeleton_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source srcSet={ImgLoaderImgWebp} type="image/webp" />
                    <source srcSet={ImgLoaderImg} type="image/png" />
                    <img src={ImgLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "mapLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="skeleton_map_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source srcSet={MapChartLoaderImgWebp} type="image/webp" />
                    <source srcSet={MapChartLoaderImg} type="image/png" />
                    <img src={MapChartLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "multiLineChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={LineLoaderImgWebp} type="image/webp" />
                  <source srcSet={LineLoaderImg} type="image/png" />
                  <img src={LineLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "multiAxisMultiLineChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source
                    srcSet={MultiLineMultiAxisLoaderImgWebp}
                    type="image/webp"
                  />
                  <source
                    srcSet={MultiLineMultiAxisLoaderImg}
                    type="image/png"
                  />
                  <img src={MultiLineMultiAxisLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "bubbleChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={BubbleLoaderImgWebp} type="image/webp" />
                  <source srcSet={BubbleLoaderImg} type="image/png" />
                  <img src={BubbleLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "treeChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={TreeChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={TreeChartLoaderImg} type="image/png" />
                  <img src={TreeChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "donutChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={DonutChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={DonutChartLoaderImg} type="image/png" />
                  <img src={DonutChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "semiDonutChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source
                    srcSet={SemiDonutChartLoaderImgWebp}
                    type="image/webp"
                  />
                  <source srcSet={SemiDonutChartLoaderImg} type="image/png" />
                  <img src={SemiDonutChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "sankeyChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={SankeyChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={SankeyChartLoaderImg} type="image/png" />
                  <img src={SankeyChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "stackedColumnChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source
                    srcSet={StackedChartLoaderImgWebp}
                    type="image/webp"
                  />
                  <source srcSet={StackedChartLoaderImg} type="image/png" />
                  <img src={StackedChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "pieChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={PieChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={PieChartLoaderImg} type="image/png" />
                  <img src={PieChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "heatChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={HeatChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={HeatChartLoaderImg} type="image/png" />
                  <img src={HeatChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "barChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={BarChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={BarChartLoaderImg} type="image/png" />
                  <img src={BarChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "solidGaugeChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source
                    srcSet={SolidGaugeChartLoaderImgWebp}
                    type="image/webp"
                  />
                  <source srcSet={SolidGaugeChartLoaderImg} type="image/png" />
                  <img src={SolidGaugeChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "combinedBarLineChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source
                    srcSet={CombinedBarLineChartLoaderImgWebp}
                    type="image/webp"
                  />
                  <source
                    srcSet={CombinedBarLineChartLoaderImg}
                    type="image/png"
                  />
                  <img src={CombinedBarLineChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "genderLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={GenderLoaderImgWebp} type="image/webp" />
                  <source srcSet={GenderLoaderImg} type="image/png" />
                  <img src={GenderLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "hashLoader" ? (
        <Wrapper>
          <div className="hash_wrapper">
            <div className="skeleton_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source srcSet={HashLoaderImgWebp} type="image/webp" />
                    <source srcSet={HashLoaderImg} type="image/png" />
                    <img src={HashLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "funnelChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={FunnelLoaderImgWebp} type="image/webp" />
                  <source srcSet={FunnelLoaderImg} type="image/png" />
                  <img src={FunnelLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "smallTableLoader" ? (
        <Wrapper>
          <div className="table_skeleton_loader">
            <div className="skeleton_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source srcSet={TableLoaderImgWebp} type="image/webp" />
                    <source srcSet={TableLoaderImg} type="image/png" />
                    <img src={TableLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "indiaMapLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="skeleton_map_wrapper">
              <div className="loader-chart">
                <picture>
                  <source srcSet={IndiaMapLoaderImgWebp} type="image/webp" />
                  <source srcSet={IndiaMapLoaderImg} type="image/png" />
                  <img src={IndiaMapLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "wordCloudLoader" ? (
        <Wrapper>
          <div className="table_skeleton_loader">
            <div className="skeleton_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source srcSet={WordCloudLoaderImgWebp} type="image/webp" />
                    <source srcSet={WordCloudLoaderImg} type="image/png" />
                    <img src={WordCloudLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "packedCircleLoader" ? (
        <Wrapper>
          <div className="table_skeleton_loader">
            <div className="skeleton_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source
                      srcSet={PackedCircleLoaderImgWebp}
                      type="image/webp"
                    />
                    <source srcSet={PackedCircleLoaderImg} type="image/png" />
                    <img src={PackedCircleLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "campaignLoader" ? (
        <Wrapper>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brands"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brands"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>
          <div
            id="campaign_objective_section"
            className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card"
          >
            <div className="grid col_span_4">
              <div className="section_card_header">
                <h2 className="section_card_title">
                  Objective Wise Distribution
                </h2>
              </div>
            </div>
            <div className="grid col_span_4">
              <div className="section_card_body">
                <div className="section_card_chart_wrapper">
                  <Wrapper>
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={PieChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={PieChartLoaderImg}
                              type="image/png"
                            />
                            <img src={PieChartLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
          </div>
          <div className="section_card section_dropdown_header">
            <div className="grid grid_cols_1">
              <div className="section_card_header">
                <h2 className="section_card_title">Performance By KPI</h2>
              </div>
            </div>
          </div>
          <div
            id="performance_source_section"
            className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card"
          >
            <div className="grid grid_cols_1">
              <div className="section_card_header">
                <h2 className="section_card_title">Performance By Source</h2>
              </div>
            </div>
            <div className="grid col_span_4">
              <div className="grid col_span_3">
                <div className="section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={LineLoaderImgWebp}
                                type="image/webp"
                              />
                              <source srcSet={LineLoaderImg} type="image/png" />
                              <img src={LineLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
              <div className="grid col_span_1">
                <div className="section_card_body">
                  <div className="table_wrapper section_card_table_wrapper">
                    <Wrapper>
                      <div className="table_skeleton_loader">
                        <div className="skeleton_wrapper">
                          <div className="section_card_chart">
                            <div className="loader-chart">
                              <picture>
                                <source
                                  srcSet={TableLoaderImgWebp}
                                  type="image/webp"
                                />
                                <source
                                  srcSet={TableLoaderImg}
                                  type="image/png"
                                />
                                <img src={TableLoaderImg} alt="loader" />
                              </picture>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card">
            <div className="grid col_span_4">
              <div className="section_card_header">
                <h2 className="section_card_title">Summary</h2>
              </div>
            </div>
            <div className="grid col_span_4">
              <div className="section_card_body">
                <Wrapper>
                  <div className="table_skeleton_loader">
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={TableLoaderImgWebp}
                              type="image/webp"
                            />
                            <source srcSet={TableLoaderImg} type="image/png" />
                            <img src={TableLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </Wrapper>
              </div>
            </div>
          </div>


          <div className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card">
            <div className="grid col_span_4">
              <div className="section_card_header">
                <h2 className="section_card_title">Planned v/s Delivered Metrics Performance</h2>
              </div>
            </div>
            <div className="grid col_span_4">
              <div className="section_card_body">
                <Wrapper>
                  <div className="table_skeleton_loader">
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={BarChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source srcSet={BarChartLoaderImg} type="image/png" />
                            <img src={BarChartLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </Wrapper>
              </div>
            </div>
          </div>



          <div className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card">
            <div className="grid col_span_4">
              <div className="section_card_header">
                <h2 className="section_card_title">Campaign wise Planned v/s Delivered table</h2>
              </div>
            </div>
            <div className="grid col_span_4">
              <div className="section_card_body">
                <Wrapper>
                  <div className="table_skeleton_loader">
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={TableLoaderImgWebp}
                              type="image/webp"
                            />
                            <source srcSet={TableLoaderImg} type="image/png" />
                            <img src={TableLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </Wrapper>
              </div>
            </div>
          </div>


        </Wrapper>
      ) : loaderType === "socialLoader" ? (
        <Wrapper>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brands"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Summary"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>

          <Wrapper>
            <div className="grid grid_cols_4 grid_margin_bottom">
              <div
                id="page_views_section"
                className="grid col_span_2 section_card"
              >
                <div className="section_card_header">
                  <h2 className="section_card_title">Page Views</h2>
                </div>
                <div className="grid grid_cols_1 section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={LineLoaderImgWebp}
                                type="image/webp"
                              />
                              <source srcSet={LineLoaderImg} type="image/png" />
                              <img src={LineLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
              <div
                id="page_growth_section"
                className="grid col_span_2 section_card"
              >
                <div className="section_card_header">
                  <h2 className="section_card_title">Page Growth</h2>
                </div>
                <div className="grid grid_cols_1 section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={BarChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={BarChartLoaderImg}
                                type="image/png"
                              />
                              <img src={BarChartLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="period_source_section"
              className="grid grid_cols_4 fullpage_section_card section_card"
            >
              <div className="grid grid_cols_4">
                <div className="grid col_span_2 card_border_right flex column">
                  <div className="section_card_header">
                    <h2 className="section_card_title">
                      Current Period Source
                    </h2>
                  </div>
                  <div className="grid grid_cols_1 section_card_body">
                    <div className="section_card_chart_wrapper">
                      <Wrapper>
                        <div className="skeleton_wrapper">
                          <div className="section_card_chart">
                            <div className="loader-chart">
                              <picture>
                                <source
                                  srcSet={StackedChartLoaderImgWebp}
                                  type="image/webp"
                                />
                                <source
                                  srcSet={StackedChartLoaderImg}
                                  type="image/png"
                                />
                                <img src={StackedChartLoaderImg} alt="loader" />
                              </picture>
                            </div>
                          </div>
                        </div>
                      </Wrapper>
                    </div>
                  </div>
                </div>
                <div className="grid col_span_2 flex column">
                  <div className="section_card_header">
                    <h2 className="section_card_title">
                      Previous Period Source
                    </h2>
                  </div>
                  <div className="grid grid_cols_1 section_card_body">
                    <div className="section_card_chart_wrapper">
                      <Wrapper>
                        <div className="skeleton_wrapper">
                          <div className="section_card_chart">
                            <div className="loader-chart">
                              <picture>
                                <source
                                  srcSet={StackedChartLoaderImgWebp}
                                  type="image/webp"
                                />
                                <source
                                  srcSet={StackedChartLoaderImg}
                                  type="image/png"
                                />
                                <img src={StackedChartLoaderImg} alt="loader" />
                              </picture>
                            </div>
                          </div>
                        </div>
                      </Wrapper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
        </Wrapper>
      ) : loaderType === "hashtagLoader" ? (
        <Wrapper>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brands"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>
          <Wrapper>
            <div className="section_card fullpage_section_card grid grid_margin_bottom">
              <div className="section_card_header">
                <h2 className="section_card_title">Trending Hashtags</h2>
              </div>
              <div className="section_card_body badges_list_wrapper_body">
                <div className="badges_list_wrapper">
                  <Wrapper>
                    <div className="hash_wrapper">
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={HashLoaderImgWebp}
                                type="image/webp"
                              />
                              <source srcSet={HashLoaderImg} type="image/png" />
                              <img src={HashLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>

            <div className="section_card fullpage_section_card grid grid_margin_bottom">
              <div className="section_card_header">
                <h2 className="section_card_title">Hashtag List</h2>
              </div>
              <div className="grid col_span_4">
                <div className="section_card_body">
                  <Wrapper>
                    <div className="table_skeleton_loader">
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={TableLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={TableLoaderImg}
                                type="image/png"
                              />
                              <img src={TableLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
            <div
              id="top_hash"
              className="section_card fullpage_section_card grid grid_margin_bottom"
            >
              <div className="section_card_header">
                <h2 className="section_card_title">Top Hashtags</h2>
              </div>
              <div className="section_card_body">
                <div className="section_card_chart_wrapper">
                  <Wrapper>
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={BarChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={BarChartLoaderImg}
                              type="image/png"
                            />
                            <img src={BarChartLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
          </Wrapper>
        </Wrapper>
      ) : loaderType === "topicLoader" ? (
        <Wrapper>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brands"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>

          <div className="section_card fullpage_section_card grid grid_margin_bottom">
            <div className="section_card_header">
              <h2 className="section_card_title">Topics</h2>
            </div>
            <div className="section_card_body badges_list_wrapper_body">
              <div className="badges_list_wrapper">
                <Wrapper>
                  <div className="hash_wrapper">
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={HashLoaderImgWebp}
                              type="image/webp"
                            />
                            <source srcSet={HashLoaderImg} type="image/png" />
                            <img src={HashLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </Wrapper>
              </div>
            </div>
          </div>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Summary"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>

          <div
            id="world_cloud_section"
            className="grid grid_cols_4 grid_margin_bottom section_card"
          >
            <div className="section_card_header">
              <div className="section_info">
                <h2 className="section_card_title">Overall Conversations</h2>
              </div>
            </div>
            <div className="grid grid_cols_1 section_card_body">
              <div className="section_card_chart_wrapper">
                <div className="grid col_span_4">
                  <div className="grid col_span_3">
                    <div className="section_card_body">
                      <div className="section_card_chart_wrapper">
                        <Wrapper>
                          <div className="skeleton_wrapper">
                            <div className="section_card_chart">
                              <div className="loader-chart">
                                <picture>
                                  <source
                                    srcSet={PackedCircleLoaderImgWebp}
                                    type="image/webp"
                                  />
                                  <source
                                    srcSet={PackedCircleLoaderImg}
                                    type="image/png"
                                  />
                                  <img
                                    src={PackedCircleLoaderImg}
                                    alt="loader"
                                  />
                                </picture>
                              </div>
                            </div>
                          </div>
                        </Wrapper>
                      </div>
                    </div>
                  </div>
                  <div className="grid col_span_1">
                    <div className="section_card_body">
                      <Wrapper>
                        <div className="table_skeleton_loader">
                          <div className="skeleton_wrapper">
                            <div className="section_card_chart">
                              <div className="loader-chart">
                                <picture>
                                  <source
                                    srcSet={TableLoaderImgWebp}
                                    type="image/webp"
                                  />
                                  <source
                                    srcSet={TableLoaderImg}
                                    type="image/png"
                                  />
                                  <img src={TableLoaderImg} alt="loader" />
                                </picture>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Wrapper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            id="world_cloud_section"
            className="grid grid_cols_4 grid_margin_bottom section_card"
          >
            <div className="section_card_header">
              <div className="section_info">
                <h2 className="section_card_title">Top Things Mentioned</h2>
              </div>
            </div>
            <div className="grid grid_cols_1 section_card_body">
              <div className="section_card_chart_wrapper">
                <Wrapper>
                  <div className="table_skeleton_loader">
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={WordCloudLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={WordCloudLoaderImg}
                              type="image/png"
                            />
                            <img src={WordCloudLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </Wrapper>
              </div>
            </div>
          </div>

          <div className="grid grid_cols_4 grid_margin_bottom">
            <div
              id="mentions_volume_by_source"
              className="grid col_span_2 section_card"
            >
              <div className="section_card_header">
                <h2 className="section_card_title">
                  Mentions Volume By Source
                </h2>
              </div>
              <div className="section_card_body">
                <div className="section_card_chart_wrapper">
                  <Wrapper>
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={BarChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={BarChartLoaderImg}
                              type="image/png"
                            />
                            <img src={BarChartLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>

            <div
              id="mentions_volume_trendline"
              className="grid col_span_2 section_card"
            >
              <div className="grid col_span_4">
                <div className="section_card_header">
                  <div className="section_info">
                    <h2 className="section_card_title">
                      Mentions Volume Trendline
                    </h2>
                  </div>
                </div>
              </div>
              <div className="grid col_span_4">
                <div className="section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={CombinedBarLineChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={CombinedBarLineChartLoaderImg}
                                type="image/png"
                              />
                              <img
                                src={CombinedBarLineChartLoaderImg}
                                alt="loader"
                              />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid_cols_4 grid_margin_bottom">
            <div
              id="Mentions_Volume_By_Day_of_Week"
              className="grid col_span_2 section_card"
            >
              <div className="section_card_header">
                <h2 className="section_card_title">
                  Mentions Volume By Day of Week
                </h2>
              </div>
              <div className="section_card_body">
                <div className="section_card_chart_wrapper">
                  <Wrapper>
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={CombinedBarLineChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={CombinedBarLineChartLoaderImg}
                              type="image/png"
                            />
                            <img
                              src={CombinedBarLineChartLoaderImg}
                              alt="loader"
                            />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
            <div
              id="Mentions_Volume_By_Time_of_the_Day"
              className="grid col_span_2 section_card"
            >
              <div className="grid col_span_4">
                <div className="section_card_header">
                  <div className="section_info">
                    <h2 className="section_card_title">
                      Mentions Volume By Time of the Day
                    </h2>
                  </div>
                </div>
              </div>
              <div className="grid col_span_4">
                <div className="section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={BarChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={BarChartLoaderImg}
                                type="image/png"
                              />
                              <img src={BarChartLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "tvLoader" ? (
        <Wrapper>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brand Performance Index"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>
          <Wrapper>
            <div className="grid grid_margin_bottom">
              <Slider
                sliderTitle={"Performance Metrics"}
                sliderWrapperClass={"tab_card_slider"}
                isSkeleton={true}
              // showSliderHeader={false}
              >
                {AllCardDataSample.map((data, index) => (
                  <SwiperSlide key={index}>
                    <Card
                      variant={"chartCard"}
                      cardTitle={data.label}
                      currentValue={data.currentValue}
                      previousValue={data.previousValue}
                    />
                  </SwiperSlide>
                ))}
              </Slider>
            </div>
            <div
              id="Performance_Trend_Section"
              className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card"
            >
              <div className="grid col_span_4">
                <div className="section_card_header">
                  <h2 className="section_card_title">Performance Trend</h2>
                </div>
              </div>
              <div className="grid col_span_4">
                <div className="section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={CombinedBarLineChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={CombinedBarLineChartLoaderImg}
                                type="image/png"
                              />
                              <img
                                src={CombinedBarLineChartLoaderImg}
                                alt="loader"
                              />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="top_genra_grp_section"
              className="grid grid_cols_2 grid_margin_bottom"
            >
              <div className="grid col_span_1 section_card">
                <div className="section_card_header">
                  <h2 className="section_card_title">Top Genre and GRPs</h2>
                </div>
                <div className="grid grid_cols_1 section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={BarChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={BarChartLoaderImg}
                                type="image/png"
                              />
                              <img src={BarChartLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>

              <div
                id="ad_duration_wise_grp_section"
                className="grid col_span_1 section_card"
              >
                <div className="section_card_header">
                  <h2 className="section_card_title">AD Duration Wise GRP</h2>
                </div>
                <div className="grid grid_cols_1 section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={BarChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={BarChartLoaderImg}
                                type="image/png"
                              />
                              <img src={BarChartLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="Brand_Wise_GRP_and_Spends_Section"
              className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card"
            >
              <div className="grid col_span_4">
                <div className="section_card_header p_b_0 ">
                  <div className="flex column align_start">
                    <h2 className="section_card_title">
                      Brand Wise GRP and Spends
                    </h2>
                  </div>
                </div>
              </div>
              <div className="grid col_span_4">
                <div className="section_card_body">
                  <div className="section_card_chart_wrapper flex column">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={TreeChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={TreeChartLoaderImg}
                                type="image/png"
                              />
                              <img src={TreeChartLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="Ad_Position_Wise_GRP_Section"
              className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card"
            >
              <div className="grid col_span_4">
                <div className="section_card_header">
                  <h2 className="section_card_title">Ad Position Wise GRP</h2>
                </div>
              </div>
              <div className="grid col_span_4 section_card_body">
                <div className="section_card_chart_wrapper">
                  <Wrapper>
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={PieChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={PieChartLoaderImg}
                              type="image/png"
                            />
                            <img src={PieChartLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
            <div className="grid grid_cols_4 fullpage_section_card section_card">
              <div className="grid col_span_4">
                <div className="section_card_header">
                  <h2 className="section_card_title">Ad/ Campaign Summary</h2>
                </div>
              </div>
              <div className="grid col_span_4 section_card_body">
                <div className="section_card_body">
                  <Wrapper>
                    <div className="table_skeleton_loader">
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={TableLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={TableLoaderImg}
                                type="image/png"
                              />
                              <img src={TableLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
          </Wrapper>
        </Wrapper>
      ) : loaderType === "tableLoader" ? (
        <div className="table_wrapper skeleton_wrapper">
          <table className="table">
            <tbody>
              <tr>
                <td data-label="Name" className="text_align">
                  Win263a84_ind_wpp_263-thums-na_localcampaign-tuicc...
                </td>
                <td data-label="Platform" className="text_align">
                  Instagram
                </td>
                <td data-label="Objective" className="text_align">
                  Outcome_awareness
                </td>
                <td data-label="Spends" className="number_align">
                  ₹5,430,708.66
                </td>
                <td data-label="Impressions" className="number_align">
                  203,828,222
                </td>
              </tr>
              <tr>
                <td data-label="Name" className="text_align">
                  Win263a84_ind_wpp_263-thums-na_localcampaign-tuicc...
                </td>
                <td data-label="Platform" className="text_align">
                  Instagram
                </td>
                <td data-label="Objective" className="text_align">
                  Outcome_awareness
                </td>
                <td data-label="Spends" className="number_align">
                  ₹5,430,708.66
                </td>
                <td data-label="Impressions" className="number_align">
                  203,828,222
                </td>
              </tr>
              <tr>
                <td data-label="Name" className="text_align">
                  Win263a84_ind_wpp_263-thums-na_localcampaign-tuicc...
                </td>
                <td data-label="Platform" className="text_align">
                  Instagram
                </td>
                <td data-label="Objective" className="text_align">
                  Outcome_awareness
                </td>
                <td data-label="Spends" className="number_align">
                  ₹5,430,708.66
                </td>
                <td data-label="Impressions" className="number_align">
                  203,828,222
                </td>
              </tr>
              <tr>
                <td data-label="Name" className="text_align">
                  Win263a84_ind_wpp_263-thums-na_localcampaign-tuicc...
                </td>
                <td data-label="Platform" className="text_align">
                  Instagram
                </td>
                <td data-label="Objective" className="text_align">
                  Outcome_awareness
                </td>
                <td data-label="Spends" className="number_align">
                  ₹5,430,708.66
                </td>
                <td data-label="Impressions" className="number_align">
                  203,828,222
                </td>
              </tr>
              <tr>
                <td data-label="Name" className="text_align">
                  Win263a84_ind_wpp_263-thums-na_localcampaign-tuicc...
                </td>
                <td data-label="Platform" className="text_align">
                  Instagram
                </td>
                <td data-label="Objective" className="text_align">
                  Outcome_awareness
                </td>
                <td data-label="Spends" className="number_align">
                  ₹5,430,708.66
                </td>
                <td data-label="Impressions" className="number_align">
                  203,828,222
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <Wrapper>
          <div className="loader-wrap">
            <div className="loader_wrapper_new">
              <div className="loader-img">
                <svg
                  width="57"
                  height="61"
                  viewBox="0 0 57 61"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="redIcon"
                    d="M3.42998 31.6717C2.58826 31.6281 1.56627 32.1384 1.14032 30.6788C0.810313 29.542 0.909168 28.8224 2.03001 28.331C2.41235 28.1638 2.83103 27.953 3.08108 27.639C3.43434 27.1956 3.87629 26.6345 3.86756 26.1315C3.85157 25.2781 3.9795 24.1776 2.66531 23.9392C2.2568 23.8651 1.88173 23.6034 1.47177 23.5263C0.134316 23.2734 -0.184057 22.5276 0.0921571 21.241C0.254978 20.4865 0.528284 20.1129 1.28133 20.0519C1.74217 20.0155 2.1972 19.8483 2.65658 19.8396C3.6873 19.8207 4.21065 19.3671 4.54647 18.3481C4.88229 17.329 4.51885 16.7489 3.78325 16.1907C3.54774 16.0133 3.33694 15.8025 3.11597 15.6092C1.96605 14.5916 1.91371 13.6481 3.0113 12.5447C3.26114 12.3412 3.57976 12.2417 3.901 12.267C4.39964 12.3062 4.8881 12.4836 5.38238 12.597C6.93063 12.9503 7.89738 12.4909 8.47306 11.0546C8.5821 10.7813 8.52831 10.3887 8.42654 10.0936C8.24841 9.57156 8.01395 9.07045 7.72729 8.59917C7.18213 7.71237 7.19667 7.05673 8.09363 6.31968C8.94699 5.61896 9.59536 5.55355 10.3862 6.28769C10.6944 6.57844 11.1131 6.74708 11.4038 7.03928C12.1787 7.79524 12.8765 7.48995 13.6819 7.05528C14.4873 6.6206 14.73 6.02747 14.5861 5.18284C14.5294 4.84993 14.5309 4.50829 14.4829 4.17393C14.3462 3.20718 14.4596 2.52537 15.627 2.16775C16.7522 1.82175 17.3962 2.04854 17.8789 3.05599C18.0431 3.39617 18.2946 3.69419 18.4822 4.02419C18.8616 4.70019 19.3079 5.16103 20.2005 4.96187C21.0931 4.7627 22.1267 4.91825 22.3317 3.62877C22.3913 3.26097 22.5847 2.91498 22.7141 2.55735C23.2839 0.958221 23.8436 0.66747 25.4544 1.26642C25.7451 1.37109 26.0068 1.75488 26.1071 2.06744C26.2897 2.63198 26.3934 3.21903 26.4153 3.81195C26.4473 4.88773 27.0201 5.3035 27.997 5.61024C28.9739 5.91698 29.5118 5.52447 30.0323 4.84557C30.2387 4.57808 30.5106 4.36001 30.7025 4.0838C31.3029 3.22754 31.9338 3.03709 32.9514 3.55608C33.969 4.07508 34.2162 4.66385 33.8557 5.66549C33.7277 6.0202 33.7335 6.42725 33.5867 6.77179C33.1462 7.81414 33.7277 8.3593 34.4546 8.99023C35.2207 9.65169 35.8924 9.75926 36.7239 9.22573C37.0059 9.04401 37.3578 8.97278 37.6369 8.78961C38.5746 8.17758 39.2462 8.30551 40.0109 9.20974C40.7755 10.114 40.5197 10.7449 39.912 11.5256C39.1561 12.4967 38.0599 13.4911 39.3189 14.7965C39.6998 15.192 40.3002 15.4333 40.8453 15.5932C41.2247 15.7037 41.6798 15.5394 42.1014 15.5205C43.6438 15.4507 44.2311 15.9566 44.282 17.5252C44.2936 17.8407 44.077 18.2419 43.8371 18.4658C43.4737 18.8074 42.9969 19.0284 42.5695 19.3017C41.8673 19.7538 41.1157 20.0868 41.2785 21.2236C41.4414 22.3604 41.674 23.2807 42.9911 23.4871C43.2818 23.5322 43.5435 23.7008 43.8284 23.7778C44.7254 24.0133 45.2749 24.3463 45.1644 25.5122C45.0539 26.6781 44.6585 27.2058 43.5348 27.2712C43.1146 27.2959 42.7003 27.4253 42.2802 27.4442C41.3032 27.4878 40.9573 28.0635 40.6912 28.9358C40.4252 29.808 40.5633 30.3895 41.2727 30.9114C41.5795 31.1353 41.8266 31.4406 42.1333 31.6616C43.0187 32.2969 43.2208 32.9612 42.68 34.0254C42.1392 35.0895 41.4166 35.0924 40.4993 34.8206C39.2127 34.4426 38.0018 34.0937 37.1063 35.6449C36.7196 36.315 36.5393 36.8195 36.9274 37.4911C37.1179 37.8182 37.2182 38.2078 37.429 38.5088C38.2736 39.6965 37.8826 40.5818 36.721 41.1662C36.3212 41.3668 35.7165 41.3581 35.2673 41.2215C34.818 41.0848 34.4052 40.6952 34.0228 40.3637C33.2669 39.7096 32.5894 39.6063 31.63 40.1326C30.6327 40.6792 30.4989 41.3843 30.6341 42.3292C30.6763 42.62 30.685 42.9194 30.7359 43.2117C30.8813 44.1057 30.7214 44.725 29.7023 45.0434C28.6832 45.3618 27.9142 45.4795 27.4112 44.3354C27.2425 43.9531 26.9271 43.6347 26.757 43.2509C26.2976 42.2129 25.4617 42.2449 24.5254 42.3234C23.5892 42.4019 23.0383 42.7988 22.8405 43.7219C22.7606 44.0897 22.5265 44.4284 22.4684 44.7977C22.2678 46.0886 21.4507 46.1773 20.3488 46.1177C19.1291 46.0523 19.0768 45.2673 18.9605 44.3994C18.7947 43.1608 18.8325 41.7172 17.0444 41.6561C16.5298 41.6387 15.9643 41.8524 15.4976 42.1024C15.1473 42.29 14.9161 42.6999 14.6254 43.0154C13.4478 44.3238 13.2559 44.3848 11.7993 43.3628C11.4867 43.1433 11.3079 42.5793 11.273 42.1562C11.2381 41.7332 11.4184 41.2447 11.5638 40.8028C11.8807 39.7852 11.7833 39.0481 10.8267 38.2878C9.87012 37.5275 9.11562 37.6161 8.20848 38.1671C7.95698 38.3125 7.64733 38.3808 7.40746 38.5466C6.52648 39.1557 5.9319 38.9013 5.27335 38.1104C4.61479 37.3196 4.40981 36.7046 5.1774 35.9298C5.31669 35.7703 5.43989 35.5974 5.5452 35.4137C6.08018 34.604 6.9597 33.944 6.1267 32.7461C5.3533 31.6557 5.4478 31.5816 3.42998 31.6717ZM31.9483 23.7851C31.973 18.697 27.9854 14.6264 22.951 14.6061C17.9167 14.5857 13.8432 18.5589 13.8113 23.5147C13.7706 28.6247 17.7364 32.7213 22.7446 32.7548C27.84 32.7824 31.9236 28.8078 31.9483 23.7851Z"
                    fill="#C43638"
                  />
                  <path
                    id="greyIcon"
                    d="M49.1724 58.6375C49.3018 60.1886 48.6767 60.9213 47.079 60.978C46.8144 60.9882 46.4655 60.7469 46.2823 60.5201C45.8854 60.0287 45.5729 59.4705 45.2211 58.9428C44.1787 57.3785 42.4589 57.2622 41.2421 58.6709C41.0197 58.9268 40.806 59.1855 40.5807 59.4414C39.5325 60.6611 38.6661 60.7323 37.4537 59.6304C37.2574 59.4501 37.1629 59.0489 37.1833 58.7654C37.2312 58.1839 37.3955 57.6024 37.5074 57.0209C37.9029 54.9449 36.7893 53.7034 34.7119 53.8982C34.4211 53.9258 34.1216 53.9462 33.8265 53.9622C32.351 54.0421 31.4511 53.2208 31.5209 51.7816C31.534 51.5112 31.8116 51.2 32.0515 51.0067C32.5472 50.6142 33.1011 50.2973 33.6274 49.9426C35.0898 48.9613 35.2076 47.1804 33.889 46.0349C33.6332 45.8124 33.373 45.5987 33.1142 45.3778C31.8189 44.2816 31.7404 43.5765 32.8671 42.2682C33.0619 42.0414 33.5183 41.9236 33.8411 41.9454C34.4226 41.9876 34.9968 42.1766 35.5769 42.2958C37.4406 42.6781 38.9016 41.3596 38.7053 39.4711C38.6748 39.1804 38.6254 38.8896 38.5992 38.5902C38.4669 37.0884 39.2243 36.254 40.7566 36.2976C41.0328 36.3049 41.373 36.5375 41.5591 36.7672C41.9559 37.2585 42.267 37.8168 42.6189 38.3445C43.5623 39.7575 45.445 39.8985 46.5571 38.6352C46.781 38.3823 46.9932 38.1206 47.2156 37.8633C48.2638 36.6421 49.2378 36.5549 50.3572 37.6714C50.5724 37.8865 50.6407 38.3532 50.6102 38.689C50.5549 39.3156 50.3746 39.932 50.2482 40.5527C49.9574 41.9905 51.1509 43.4079 52.6323 43.3745C53.0132 43.3672 53.3941 43.3396 53.7721 43.3047C55.6111 43.139 55.5805 43.1462 56.1228 44.9038C56.3394 45.606 56.162 46.0261 55.5515 46.3663C55.0732 46.6353 54.6225 46.9478 54.1646 47.2589C53.8509 47.4619 53.5884 47.7347 53.3976 48.056C53.2068 48.3772 53.0929 48.7383 53.0647 49.1108C53.0366 49.4834 53.095 49.8575 53.2353 50.2038C53.3757 50.55 53.5942 50.8592 53.8738 51.107C54.1753 51.4037 54.4958 51.6805 54.8333 51.9356C55.6838 52.5172 55.9251 53.1176 55.4235 54.1643C54.9031 55.2473 54.2693 55.429 53.2226 55.1383C52.1148 54.9275 50.9053 54.535 49.9153 55.6631C48.7392 56.5731 49.152 58.3845 49.1724 58.6375ZM47.864 48.6065C47.8538 46.4637 45.9916 44.6436 43.8589 44.6916C41.7262 44.7396 39.9905 46.5233 39.9977 48.6167C40.0119 49.664 40.4401 50.663 41.1887 51.3955C41.9372 52.128 42.9453 52.5344 43.9926 52.5259C46.0846 52.4808 47.8727 50.6752 47.8626 48.6007L47.864 48.6065Z"
                    fill="#4E4E50"
                  />
                </svg>
              </div>
              <div className="loader-info">
                {title === undefined || message === undefined ?
                  <Wrapper>
                    <p className="info1">Loading Data</p>
                    <p>Please wait while we are loading all of your data</p>
                  </Wrapper>
                  :
                  <Wrapper>
                    <p className="info1">{title}</p>
                    <p>{message}</p>
                  </Wrapper>
                }
              </div>
            </div>
          </div>
        </Wrapper>
      )}
    </Wrapper>
  );
};

Loader.propTypes = {
  loaderType: PropTypes.string,
  variantType: PropTypes.string,
};

export default Loader;
